/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CustomerSuggestionConfigDto, CustomerSuggestionConfigUpdateDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAccountingAutomationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-accounting-automation-controller
   * @name GetConfiguration
   * @request GET:/api/v1/accounting-automation/model/configuration
   */
  getConfiguration = (params: RequestParams = {}) =>
    this.http.request<CustomerSuggestionConfigDto, any>({
      path: `/v1/accounting-automation/model/configuration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getConfigurationPath = '/v1/accounting-automation/model/configuration'
  static getConfigurationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-accounting-automation-controller
   * @name UpdateConfiguration
   * @request PUT:/api/v1/accounting-automation/model/configuration
   */
  updateConfiguration = (data: CustomerSuggestionConfigUpdateDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/accounting-automation/model/configuration`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateConfigurationPath = '/v1/accounting-automation/model/configuration'
  static updateConfigurationMethod = 'PUT'
}
